import { getRequest } from 'config/Axios/baseConfig';
import {
  ApiResponse,
  CleanCalculationsResponse,
} from 'Interfaces/CalculationInterfaces/MainCalculationInterfaces';

export const cleanCalculationServices = {
  getCleanCalculations: (
    date?: string,
    includeCompleted: boolean = false
  ): Promise<CleanCalculationsResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        // Use today's date if no date is provided
        const targetDate = date || new Date().toISOString().split('T')[0];

        const { data } = await getRequest<ApiResponse<CleanCalculationsResponse>>(
          `pps/calculations/get-clean-calculations/?date=${targetDate}&include_completed=${includeCompleted}`
        );

        resolve(data.data || []);
      } catch (error: any) {
        reject(error);
      }
    });
  }
};
